import React, { useEffect, useRef } from "react";


export default function AreaCarousel() {
const carouselRef = useRef(null);

const areas = [
"Kankarbagh",
"Boring Road",
"Rajendra Nagar",
"Patliputra",
"Danapur",
"Fraser Road",
"Bailey Road",
"Ashiana Nagar",
"Gardanibagh",
"Phulwari Sharif",
"Kurji",
"Anisabad",
"Saguna More",
"Gola Road",
"Patna City",
"Khajpura",
"Rajiv Nagar",
"Bhootnath Road",
"Lohiya Nagar",
"Digha",
];

useEffect(() => {
const el = carouselRef.current;
let scrollAmount = 0;

const interval = setInterval(() => {
if (!el) return;
scrollAmount += 2;
if (scrollAmount >= el.scrollWidth - el.clientWidth) scrollAmount = 0;
el.scrollBy({ left: 2, behavior: 'smooth' });
}, 50);

return () => clearInterval(interval);
}, []);


const scrollLeft = () => {
carouselRef.current.scrollBy({ left: -200, behavior: "smooth" });
};


const scrollRight = () => {
carouselRef.current.scrollBy({ left: 200, behavior: "smooth" });
};
return (
<section className="area-section">
<h2>Our Service Areas in Patna</h2>
<div className="carousel-wrapper">
<button className="carousel-btn left" onClick={scrollLeft}>‹</button>


<div className="area-carousel" ref={carouselRef}>
{areas.map((a, i) => (
<span key={i} className="area-chip">{a}</span>
))}
</div>


<button className="carousel-btn right" onClick={scrollRight}>›</button>
</div>
</section>
);
}